<template>
  <div>
    <div>
      <!-- Evento già creato - modalità modifica -->
      <template v-if="event.idWorldEvent">
        <!-- l'evento è aziendale e ho selezionato l'azienda ma non sono invitato -->
        <template v-if="inviteWork && this.currentWork !='my' && invite === null">
          <form @submit="checkForm">
            <div class="anm22-calendar-wrapper-calendar">
              <div class="wg-row">
                <div class="anm22-calendar-label-tiny wg-col wg-md-4 wg-xs-12">
                  {{$anm22.strLang(lang, 'Name Event', 'Nome Evento')}}
                </div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <input disabled
                    required
                    class="anm22-calendar-input-text"
                    id="name"
                    type="text"
                    v-model="event.name"
                    :placeholder="$anm22.strLang(lang, 'Insert name...', 'Inserisci nome evento...')"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div class="anm22-calendar-label-tiny wg-md-4 wg-xs-12">
                  {{$anm22.strLang(lang, 'Calendar', 'Calendario')}}
                </div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <select disabled required class="com-anm22-app-select" v-model="event.work">   
                  <option v-for="(obj,index) in works"
                      :key="'work-'+index"
                      :value="obj.idWorldWork"
                    ><span v-if="currentWork!=obj.name"> {{ obj.name }}</span></option>
                  </select>
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Start', 'Inizio')}}</div>
                <div class="wg-col wg-xs-7 wg-md-5">
                  <input disabled id="start-date" type="date" v-model="startDate" required>
                </div>
                <div class="wg-col wg-xs-5 wg-md-3">
                  <input disabled type="time" v-model="startTime">
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'End', 'Fine')}}</div>
                <div class="wg-col wg-xs-7 wg-md-5">
                  <input disabled id="end-date" type="date" v-model="endDate" required>
                </div>
                <div class="wg-col wg-xs-5 wg-md-3">
                  <input disabled type="time" v-model="endTime">
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">
                  {{ $anm22.strLang(lang, 'Timezone', 'Fuso orario') }}
                </div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <select disabled class="input-elem com-anm22-app-select" v-model="event.timezone">
                    <option
                      :value="''"
                      selected
                      disabled hidden
                    >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                    <option
                      disabled
                      hidden 
                      v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                      :key="'timezone-'+index"
                      :value="key"
                    >{{ obj[lang] }}</option>
                  </select>
                </div>
              </div>
            </div>
            <div class="clear"></div>
            <hr>
            <div class="anm22-calendar-wrapper-calendar" style="padding-top:0;">
              <hr>
              <div class="anm22-calendar-label">
                {{ $anm22.strLang(lang, 'Location', 'Luogo') }}
                <span class="labelFieldPlace"></span>
              </div>
              <hr>
              <template v-if="event.placeCity">
                <iframe
                  width="100%"
                  height="450"
                  frameborder="0" style="border:0"
                  :src="'https://www.google.com/maps/embed/v1/place?key='+ mapsAPIKey +'&q=' + googleQuery" allowfullscreen>
                </iframe>
              </template>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Name Location', 'Nome Luogo')}}</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <input 
                    class="anm22-calendar-input-text"
                    type="text"
                    disabled
                    v-model="event.placeName"
                    :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Address', 'Indirizzo')}}</div>
                <div class="wg-col wg-xs-12 wg-md-6">
                  <input disabled
                    class="anm22-calendar-input-text"
                    type="text"
                    v-model="event.placeStreet"
                    :placeholder="$anm22.strLang(lang, 'Street...', 'Via...')"
                  >
                </div>
                <div class="wg-col wg-xs-12 wg-md-2">
                  <input disabled
                    class="anm22-calendar-input-text"
                    type="text"
                    v-model="event.placeNumber"
                    :placeholder="$anm22.strLang(lang, 'N...', 'N.civico...')"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'City', 'Città')}}</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <input disabled
                    class="anm22-calendar-input-text"
                    type="text"
                    :placeholder="$anm22.strLang(lang, 'City...', 'Città...')"
                    v-model="event.placeCity"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">C.A.P</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <input disabled
                    class="anm22-calendar-input-text"
                    type="text"
                    :placeholder="$anm22.strLang(lang, 'Postal Code...', 'CAP...')"
                    v-model="event.placeZip"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Province', 'Provincia')}}</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <input disabled
                    class="anm22-calendar-input-text"
                    type="text"
                    name="place_state"
                    value
                    :placeholder="$anm22.strLang(lang, 'Province...', 'Provincia...')"
                    v-model="event.placeState"
                  >
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Country', 'Paese')}}</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <select disabled class="input-elem com-anm22-app-select" v-model="event.placeCountry">
                    <option disabled
                      v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
                      :key="'country-'+index"
                      :value="key"
                    >{{ obj[lang] }}</option>
                  </select>
                </div>
              </div>
              <hr>
              <div class="wg-row">
                <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Notes', 'Note')}}</div>
                <div class="wg-col wg-xs-12 wg-md-8">
                  <textarea disabled v-model="event.notes" rows="3" name="notes"></textarea>
                </div>
              </div>
            </div>
            <!-- LINK AL PROGETTO TASKS SE PRESENTE -->
            <div v-if="event.projectRef" class="wg-row">
              <div class="anm22-calendar-wrapper-calendar">
                <div class="anm22-calendar-label">
                  {{ $anm22.strLang(lang, 'Project', 'Progetto') }}
                </div>
                <a 
                    :href="'https://tasks.anm22.it/project/' + event.projectRef"
                    class="wg-row project-link" 
                    :style="{borderLeft: '3px solid ' + projectBorderColor}"
                >
                  <img :src="$anm22.icons.getWorldIcon('menuTasks')" class="com-anm22-app-img-fixed-height-m" style="margin-right:10px;" />
                  <div class="com-anm22-app-text-xl" >
                    {{ event.projectName }}
                  </div>
                </a>
              </div>
            </div>
            <!-- ---------------------------------------------- -->
            <hr style='color:#ccc;'>
            <span v-if="event.idWorldEvent">
              <div class="anm22-calendar-wrapper-calendar">
                <div class="anm22-calendar-label">{{$anm22.strLang(lang, 'Invited', 'Invitati')}}</div>
                <p v-if="errors.length">
                  <b>{{$anm22.strLang(lang, 'Alert Messagge', 'Messaggio Informativo')}}</b>
                  <ul>
                    <li v-for="(error, index) in errors" :key="'error'+index">{{ error }}</li>
                  </ul>
                </p>
                <span v-for="(obj,index) in invites" :key="'invite-'+index">
                  <span v-for="(utente, index) in users" :key="'usr'+index">
                    <span v-if="utente.idWorldUser == obj.user">
                      <div class="anm22-calendar-invite-container">
                        <img
                            class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                            :src="$anm22.getObjIcon(utente, 'userDefault')"
                          >
                        <div class="anm22-calendar-field-inline">
                          {{utente.name}} {{utente.surname}}
                          <span style="color: #aaa;">
                            {{ $anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}
                          </span>
                            -
                          <span style="color: #aaa;">
                            {{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}
                          </span>
                          <div style="display: block;"></div>
                        </div>
                      </div>
                    </span>
                  </span>
                </span>
                <hr>
              </div>
            </span>
          </form>
        </template>
        <!-- ------------------------------------------------------------------------------------------------- -->
        <template v-else>
          <!-- INVITO -->
          <div v-if="invite!=null">
            <!-- INVITO >> AMMINISTRATORE EVENTO -->
            <div v-if="invite.permission== 1">
              <form @submit="checkForm">
                <div class="anm22-calendar-wrapper-calendar">
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Name Event', 'Nome Evento')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input 
                        required
                        class="anm22-calendar-input-text"
                        id="name"
                        type="text"
                        v-model="event.name"
                        :placeholder="$anm22.strLang(lang, 'Insert name...', 'Inserisci nome evento...')"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select class="com-anm22-app-select" v-model="event.work">
                        <option value="0">{{ $anm22.strLang(lang, 'Private', 'Privato') }}</option>
                        <option
                          v-for="(obj,index) in works"
                          :key="'work-'+index"
                          :value="obj.idWorldWork"
                        >{{ obj.name }}</option>
                      </select>
                    </div>
                  </div>
                  <div class="clear"></div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Start', 'Inizio')}}</div>
                    <div class="wg-col wg-xs-7 wg-md-5">
                      <input id="start-date" type="date" v-model="startDate" required>
                    </div>
                    <div class="wg-col wg-xs-5 wg-md-3">
                      <input type="time" v-model="startTime">
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'End', 'Fine')}}</div>
                    <div class="wg-col wg-xs-7 wg-md-5">
                      <input id="end-date" type="date" v-model="endDate" required>
                    </div>
                    <div class="wg-col wg-xs-5 wg-md-3">
                      <input type="time" v-model="endTime">
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">Timezone</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select class="input-elem com-anm22-app-select" v-model="event.timezone">
                        <option
                          v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                          :key="'timezone-'+index"
                          :value="key"
                        >{{ obj[lang] }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="clear"></div>
                <hr>
                <div class="anm22-calendar-wrapper-calendar" style="padding-top:0;">
                  <hr>
                  <div class="anm22-calendar-label">
                    {{ $anm22.strLang(lang, 'Location', 'Luogo') }}
                    <span class="labelFieldPlace"></span>
                  </div>
                  <hr>
                  <template v-if="event.placeCity">
                    <iframe
                        width="100%"
                        height="450"
                        frameborder="0" style="border:0"
                        :src="'https://www.google.com/maps/embed/v1/place?key='+ mapsAPIKey +'&q=' + googleQuery" allowfullscreen>
                    </iframe>
                  </template>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Name Location', 'Nome Luogo')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <wg-search 
                        v-if="!event.placeName && manual==false"
                        :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                        :url="'events/getplaces'" 
                        :debounceTime="2000"
                        :clickFn="addPlace"
                        :canAdd="true"
                        :addFn="() => manual = true"
                      ></wg-search>
                      <!-- <input v-if="manual == true"
                      class="anm22-calendar-input-text"
                        type="text"
                        v-model="event.placeName"
                        :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                        > -->
                      <input
                          class="anm22-calendar-input-text"
                          type="text"
                          v-model="event.placeName"
                          :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                        >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Address', 'Indirizzo')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-6">
                      <input
                        class="anm22-calendar-input-text"
                        type="text"
                        v-model="event.placeStreet"
                        :placeholder="$anm22.strLang(lang, 'Street...', 'Via...')"
                      >
                    </div>
                    <div class="wg-col wg-xs-12 wg-md-2">
                      <input
                        class="anm22-calendar-input-text"
                        type="text"
                        v-model="event.placeNumber"
                        :placeholder="$anm22.strLang(lang, 'N...', 'N.civico...')"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'City', 'Città')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input
                        class="anm22-calendar-input-text"
                        type="text"
                        :placeholder="$anm22.strLang(lang, 'City...', 'Città...')"
                        v-model="event.placeCity"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">C.A.P</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input
                        class="anm22-calendar-input-text"
                        type="text"
                        :placeholder="$anm22.strLang(lang, 'Postal Code...', 'CAP...')"
                        v-model="event.placeZip"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Province', 'Provincia')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input
                        class="anm22-calendar-input-text"
                        type="text"
                        name="place_state"
                        value
                        :placeholder="$anm22.strLang(lang, 'Province...', 'Provincia...')"
                        v-model="event.placeState"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Country', 'Paese')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select class="input-elem com-anm22-app-select" v-model="event.placeCountry">
                        <option
                          v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
                          :key="'country-'+index"
                          :value="key"
                        >{{ obj[lang] }}</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Notes', 'Note')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <textarea v-model="event.notes" rows="3" name="notes"></textarea>
                    </div>
                  </div>
                </div>
                <!-- INVITO >> INVITO AMMINISTRATORE >> EVENTO DA CREARE -->
                <span v-if="!event.idWorldEvent">
                  <input
                    type="submit"
                    :value="$anm22.strLang(lang, 'Add event','Aggiungi evento')"
                    class="action-button anm22-calendar-input-submit"
                  >
                </span>
                <!-- INVITO >> INVITO AMMINISTRATORE >> EVENTO CREATO -->
                <span v-else>
                  <div class="wg-row" style="border-bottom:1px solid #ccc">
                    <input
                      type="button"
                      class="action-button anm22-calendar-input-submit"
                      @click="update"
                      :value="$anm22.strLang(lang, 'Save', 'Salva')"
                    >
                  </div>
                  <!-- LINK AL PROGETTO TASKS SE PRESENTE + MODIFICA ASSOCIAZIONE -->
                  <div class="wg-row">
                    <div class="anm22-calendar-wrapper-calendar">
                      <div class="anm22-calendar-label">
                        {{ $anm22.strLang(lang, 'Project', 'Progetto') }}
                      </div>
                      <a 
                          v-if="event.projectRef"
                          :href="'https://tasks.anm22.it/project/' + event.projectRef"
                          class="wg-row project-link" 
                          :style="{borderLeft: '3px solid ' + projectBorderColor}"
                      >
                        <img :src="$anm22.icons.getWorldIcon('menuTasks')" class="com-anm22-app-img-fixed-height-m" style="margin-right:10px;" />
                        <div class="com-anm22-app-text-xl" >
                          {{ event.projectName }}
                        </div>
                      </a>
                      <div v-else class="wg-row com-anm22-app-text-xl">
                        {{ $anm22.strLang(lang, 'No project linked', 'Nessun progetto associato') }}
                      </div>
                      <!-- Barra di ricerca per la modifica dell'associazione -->
                      <div v-if="canEditProjectLink">
                        <div v-if="!editingProject" class="wg-row">
                          <input
                            type="button"
                            class="action-button anm22-calendar-input-button"
                            style="margin-top:10px;"
                            @click="editProjectRef"
                            :value="$anm22.strLang(lang, 'Edit', 'Modifica')" 
                          >
                        </div>
                        <div class="vertical-height-div" style="height:10px;"></div>
                        <div class="wg-row" style="align-items:center;flex-wrap:nowrap;justify-content:space-between;">
                          <select 
                              class="com-anm22-app-select" 
                              v-model="projectSelect"
                              >  
                            <option 
                                v-for="(p,index) in projectOptions"
                                :key="'proj-'+index"
                                :value="p.id"
                                > 
                              {{ p.label }}
                            </option>
                          </select>
                          <div class="display-flex" style="justify-content:space-between;">
                            <div 
                                class="display-flex icon-button" 
                                @click="setProjectLink">
                              <img 
                                  class="com-anm22-app-img-fixed-height-m"
                                  :src="$anm22.icons.getWorldIcon('tick')">
                            </div>
                            <div 
                                class="display-flex icon-button" 
                                @click="stopEditProjectRef">
                              <img 
                                  class="com-anm22-app-img-fixed-height-s"
                                  :src="$anm22.icons.getWorldIcon('deleteBlack')">
                            </div>
                            <div 
                                class="display-flex icon-button" 
                                @click="deleteProjectRef">
                              <img 
                                  class="com-anm22-app-img-fixed-height-m"
                                  :src="$anm22.icons.getWorldIcon('deleteBin')">
                            </div>
                          </div>
                          <!-- <input
                            type="button"
                            class="action-button anm22-calendar-input-button"
                            @click="setProjectLink"
                            :value="$anm22.strLang(lang, 'Save', 'Salva')" 
                          > -->
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- ---------------------------------------------- -->
                  <hr style='color:#ccc;'>
                  <!-- INVITO >> AMMINISTRATORE >> EVENTO CREATO >> GESTIONE INVITATI -->
                  <span v-if="event.idWorldEvent">
                    <div class="anm22-calendar-wrapper-calendar">
                      <div class="anm22-calendar-label">{{$anm22.strLang(lang, 'Invited', 'Invitati')}}</div>
                      <p v-if="errors.length">
                        <b>{{$anm22.strLang(lang, 'Alert Messagge', 'Messaggio Informativo')}}</b>
                        <ul>
                          <li v-for="(error, index) in errors" :key="'error'+index">{{ error }}</li>
                        </ul>
                      </p>
                      <span v-for="(obj,index) in invites" :key="'invite-'+index">
                        <template v-if="!obj.user">
                          <div class="anm22-calendar-invite-container anm22-calendar-wrapper" style="box-shadow:none">
                            <img
                                class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                                :src="$anm22.getObjIcon(obj.user, 'userDefault')"
                              >
                            {{obj.email}}
                            <span
                                style="color: #aaa;"
                              >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                            -
                            <span
                                style="color: #bbb;"
                              >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                            <template v-if="event.creator == idUsr">
                              <img
                                  @click="delInvite(obj.idWorldEventInvite)"
                                  style="cursor:pointer"
                                  title="Rimuovi invitato"
                                  :src="$anm22.icons.getWorldIcon('deleteRed')"
                                  class="anm22-calendar-icon-inline"
                                >   
                            </template>
                          </div>
                        </template>
                        <span v-for="(utente, index) in users" :key="'usr'+index">
                          <span v-if="utente.idWorldUser == obj.user">
                            <div class="anm22-calendar-invite-container">
                              <img
                                class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                                :src="$anm22.getObjIcon(utente, 'userDefault')"
                              >
                              <div class="anm22-calendar-field-inline">
                                {{utente.name}} {{utente.surname}}
                                <span
                                    style="color: #aaa;"
                                  >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                                -
                                <span
                                    style="color: #aaa;"
                                  >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                                <div style="display: block;">
                                    
                                  <div v-if="obj.status == 1 && idUsr == obj.user">
                                    <br>
                                    <small>
                                      <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                        <img
                                          :src="$anm22.icons.getWorldIcon('deleteRed')"
                                          class="anm22-calendar-icon-inline"
                                        >
                                        <div class="anm22-calendar-field-inline">
                                          <small
                                            @click="eventStatus(obj.idWorldEventInvite,2)"
                                          >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                        </div>
                                      </div>
                                      <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                        <img
                                          :src="$anm22.icons.getWorldIcon('maybe')"
                                          class="anm22-calendar-icon-inline"
                                        >
                                        <div class="anm22-calendar-field-inline">
                                          <small
                                            @click="eventStatus(obj.idWorldEventInvite, 3)"
                                          >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                        </div>
                                      </div>
                                    </small>
                                  </div>
                                  <div v-if="obj.status == 2 && idUsr == obj.user">
                                    <br>
                                    <small>
                                      <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                        <img
                                          :src="$anm22.icons.getWorldIcon('tick')"
                                          class="anm22-calendar-icon-inline"
                                        >
                                        <div class="anm22-calendar-field-inline">
                                          <small
                                            @click="eventStatus(obj.idWorldEventInvite, 1)"
                                          >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                        </div>
                                      </div>
                                      <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                        <img
                                          :src="$anm22.icons.getWorldIcon('maybe')"
                                          class="anm22-calendar-icon-inline"
                                        >
                                        <div class="anm22-calendar-field-inline">
                                          <small
                                            @click="eventStatus(obj.idWorldEventInvite, 3)"
                                          >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                        </div>
                                      </div>
                                
                                    </small>
                                  </div>
                                </div>
                                <div v-if="obj.status == 3 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                  </small>
                                </div>
                              </div>
                              <!-- INVITO >> AMMINISTRATORE >> EVENTO CREATO >> GESTIONE INVITATI >> AGGIUNTA INVITATI -->
                              <template v-if="obj.permission==1 && utente.idWorldUser==idUsr">
                                <br>
                                <br>
                                <div class="wg-row" v-if="!manualEmployee">
                                  <div class="anm22-calendar-label-tiny-inline wg-col wg-md-1 wg-xs-1">
                                    <img class="marg" width="20px" :src="$anm22.icons.getWorldIcon('addGreen')">
                                  </div>
                                  <div class="wg-col wg-xs-11 wg-md-11">
                                    <wg-search
                                      :placeholder="$anm22.strLang(lang, 'Add Invitated', 'Aggiungi Invitati')"
                                      :url="'events/getemployees'"
                                      :debounceTime="2000"
                                      :clickFn="addEmployee"
                                      :canAdd="true"
                                      :addFn="() => manualEmployee = true"
                                    ></wg-search>
                                  </div>
                                </div>
                                <div v-else>
                                  <div class="wg-row">
                                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-8 wg-xs-8">
                                      <input
                                        class="anm22-calendar-input-text"
                                        type="email"
                                        v-model="emailExt"
                                        :placeholder="$anm22.strLang(lang, 'Add email...', 'Inserisci Email...')"
                                      >
                                    </div>
                                    <div class="wg-col wg-xs-4 wg-md-4">
                                      <input
                                          type="button"
                                          class="action-button anm22-calendar-input-submit"
                                          @click="inviteExt"
                                          :value="$anm22.strLang(lang, 'Invite', 'Invita')" 
                                        >
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <!-- INVITO >> AMMINISTRATORE >> EVENTO CREATO >> GESTIONE INVITATI >> UTENTE INVITATO NON CREATORE EVENTO -->
                              <template v-if="obj.user!=event.creator">
                                <template v-if="event.creator == idUsr">
                                  <img
                                    @click="delInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Rimuovi invitato"
                                    :src="$anm22.icons.getWorldIcon('deleteRed')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                  <img
                                    v-if="obj.permission==0"
                                    @click="adminInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Nomina Admin"
                                    :src="$anm22.icons.getWorldIcon('userAdminAdd')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                  <img
                                    v-else
                                    @click="delAdminInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Remove Admin"
                                    :src="$anm22.icons.getWorldIcon('userAdminRemove')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                </template>
                                <template v-if="obj.status == 0  && utente.idWorldUser==idUsr ">
                                  <br>
                                  <div style="display: block;">
                                    <br>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </template>
                              <div class="anm22-calendar-icon-container"></div>
                              <div style="clear:both;"></div>
                            </div>
                          </span>
                        </span>
                      </span>
                      <hr>
                    </div>
                  </span>
                  <!-- INVITO >> AMMINISTRATORE >> ELIMINAZIONE EVENTO -->
                  <template v-if="event.creator == idUsr">
                    <div class="wg-row">
                      <div class="" @click="deleteEvent" style="cursor:pointer">
                        <img :src="$anm22.icons.getWorldIcon('deleteRed')" class="anm22-calendar-icon-inline">
                        <div class="anm22-calendar-field-inline anm22-calendar-field-inline-m">{{$anm22.strLang(lang, 'Delete Event', 'Elimina Evento')}}</div>
                      </div>
                    </div>
                  </template> 
                </span>
              </form>
            </div>
            <!-- INVITO >> NON AMMINISTRATORE -->
            <div v-else>
              <form @submit="checkForm">
                <div class="anm22-calendar-wrapper-calendar">
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Name Event', 'Nome Evento')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input disabled
                        required
                        class="anm22-calendar-input-text"
                        id="name"
                        type="text"
                        v-model="event.name"
                        :placeholder="$anm22.strLang(lang, 'Insert name...', 'Inserisci nome evento...')"
                      >
                    </div>
                  </div>
                  <hr>
                  <hr>
                  <div class="wg-row">
                    <div
                        class="anm22-calendar-label-tiny wg-md-4 wg-xs-12"
                        >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select disabled required class="com-anm22-app-select" v-model="event.work">
                        <option value="0"> Privato </option>   
                        <option v-for="(obj,index) in works"
                            :key="'work-'+index"
                            :value="obj.idWorldWork"
                          ><span v-if="currentWork!=obj.name"> {{ obj.name }}</span></option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Start', 'Inizio')}}</div>
                    <div class="wg-col wg-xs-7 wg-md-5">
                      <input disabled type="date" v-model="startDate" required>
                    </div>
                    <div class="wg-col wg-xs-5 wg-md-3">
                      <input disabled type="time" v-model="startTime">
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'End', 'Fine')}}</div>
                    <div class="wg-col wg-xs-7 wg-md-5">
                      <input disabled id="end-date" type="date" v-model="endDate" required>
                    </div>
                    <div class="wg-col wg-xs-5 wg-md-3">
                      <input disabled type="time" v-model="endTime">
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">Timezone</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select disabled class="input-elem com-anm22-app-select" v-model="event.timezone">
                        <option
                          :value="''"
                          selected
                          disabled
                        >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                        <option
                        disabled
                          v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                          :key="'timezone-'+index"
                          :value="key"
                        >{{ obj[lang] }}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="clear"></div>

                <hr>
                <div class="anm22-calendar-wrapper-calendar" style="padding-top:0;">
                  <hr>
                  <div class="anm22-calendar-label">
                    {{ $anm22.strLang(lang, 'Location', 'Luogo') }}
                    <span class="labelFieldPlace"></span>
                  </div>
                  <hr>
                  <template v-if="event.placeCity">
                    <iframe
                        width="100%"
                        height="450"
                        frameborder="0" style="border:0"
                        :src="'https://www.google.com/maps/embed/v1/place?key='+ mapsAPIKey +'&q=' + googleQuery" allowfullscreen>
                    </iframe>
                  </template>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Name Location', 'Nome Luogo')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input 
                        class="anm22-calendar-input-text"
                        type="text"
                        disabled
                        v-model="event.placeName"
                        :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Address', 'Indirizzo')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-6">
                      <input disabled
                        class="anm22-calendar-input-text"
                        type="text"
                        v-model="event.placeStreet"
                        :placeholder="$anm22.strLang(lang, 'Street...', 'Via...')"
                      >
                    </div>
                    <div class="wg-col wg-xs-12 wg-md-2">
                      <input disabled
                        class="anm22-calendar-input-text"
                        type="text"
                        v-model="event.placeNumber"
                        :placeholder="$anm22.strLang(lang, 'N...', 'N.civico...')"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'City', 'Città')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input disabled
                        class="anm22-calendar-input-text"
                        type="text"
                        :placeholder="$anm22.strLang(lang, 'City...', 'Città...')"
                        v-model="event.placeCity"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">C.A.P</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input disabled
                        class="anm22-calendar-input-text"
                        type="text"
                        :placeholder="$anm22.strLang(lang, 'Postal Code...', 'CAP...')"
                        v-model="event.placeZip"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Province', 'Provincia')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <input disabled
                        class="anm22-calendar-input-text"
                        type="text"
                        name="place_state"
                        value
                        :placeholder="$anm22.strLang(lang, 'Province...', 'Provincia...')"
                        v-model="event.placeState"
                      >
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Country', 'Paese')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <select disabled class="input-elem com-anm22-app-select" v-model="event.placeCountry">
                        <option disabled
                          v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
                          :key="'country-'+index"
                          :value="key"
                        >{{ obj[lang] }}</option>
                      </select>
                    </div>
                  </div>
                  <hr>
                  <div class="wg-row">
                    <div
                      class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Notes', 'Note')}}</div>
                    <div class="wg-col wg-xs-12 wg-md-8">
                      <textarea disabled v-model="event.notes" rows="3" name="notes"></textarea>
                    </div>
                  </div>
                </div>
                <span v-if="!event.idWorldEvent">
                  <input
                    type="submit"
                    :value="$anm22.strLang(lang, 'Add event','Aggiungi evento')"
                    class="action-button anm22-calendar-input-submit"
                  >
                </span>
                <span v-else>
                  <!-- LINK AL PROGETTO TASKS SE PRESENTE -->
                  <div v-if="event.projectRef" class="wg-row">
                    <div class="anm22-calendar-wrapper-calendar">
                      <div class="anm22-calendar-label">
                        {{ $anm22.strLang(lang, 'Project', 'Progetto') }}
                      </div>
                      <a 
                          :href="'https://tasks.anm22.it/project/' + event.projectRef"
                          class="wg-row project-link" 
                          :style="{borderLeft: '3px solid ' + projectBorderColor}"
                      >
                      <img :src="$anm22.icons.getWorldIcon('taskIcon')" class="com-anm22-app-img-fixed-height-m" style="margin-right:10px;" />
                      <div class="com-anm22-app-text-xl" >
                        {{ event.projectName }}
                      </div>
                    </a>
                    </div>
                  </div>
                  <!-- ---------------------------------------------- -->
                  <hr style='color:#ccc;'>
                  <span v-if="event.idWorldEvent">
                    <div class="anm22-calendar-wrapper-calendar">
                      <div class="anm22-calendar-label">{{$anm22.strLang(lang, 'Invited', 'Invitati')}}</div>
                      <p v-if="errors.length">
                        <b>{{$anm22.strLang(lang, 'Alert Messagge', 'Messaggio Informativo')}}</b>
                        <ul>
                          <li v-for="(error, index) in errors" :key="'error'+index">{{ error }}</li>
                        </ul>
                      </p>
                      <span v-for="(obj,index) in invites" :key="'invite-'+index">
                        <template v-if="!obj.user">
                          <div class="anm22-calendar-invite-container anm22-calendar-wrapper" style="box-shadow:none">
                            <img
                                class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                                :src="$anm22.getObjIcon(obj.user, 'userDefault')"
                              >
                              {{obj.email}}
                            <span
                                style="color: #aaa;"
                              >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                            -
                            <span
                                style="color: #bbb;"
                              >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                            <template v-if="event.creator == idUsr">
                              <img
                                @click="delInvite(obj.idWorldEventInvite)"
                                style="cursor:pointer"
                                title="Rimuovi invitato"
                                :src="$anm22.icons.getWorldIcon('deleteRed')"
                                class="anm22-calendar-icon-inline"
                              >   
                            </template>
                          </div>
                        </template>
                        <span v-for="(utente, index) in users" :key="'usr'+index">
                          <span v-if="utente.idWorldUser == obj.user">
                            <div class="anm22-calendar-invite-container">
                              <img
                                class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                                :src="$anm22.getObjIcon(utente, 'userDefault')"
                              >
                              <div class="anm22-calendar-field-inline">
                                {{utente.name}} {{utente.surname}}
                                <span
                                  style="color: #aaa;"
                                >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                                -
                                <span
                                  style="color: #aaa;"
                                >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                                <div style="display: block;">
                                    
                                <div v-if="obj.status == 1 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite,2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                                  </small>
                                </div>
                                <div v-if="obj.status == 2 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                              
                                  </small>
                                </div>
                                </div>
                                <div v-if="obj.status == 3 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                  </small>
                                </div>
                              </div>
                              <template v-if="obj.permission==1 && utente.idWorldUser==idUsr">
                                <br>
                                <br>
                                <div class="wg-row" v-if="!manualEmployee">
                                  <div class="anm22-calendar-label-tiny-inline wg-col wg-md-1 wg-xs-1">
                                    <img class="marg" width="20px" :src="$anm22.icons.getWorldIcon('addGreen')">
                                  </div>
                                    <div class="wg-col wg-xs-11 wg-md-11">
                                      <wg-search
                                        :placeholder="$anm22.strLang(lang, 'Add Invitated', 'Aggiungi Invitati')"
                                        :url="'events/getemployees'"
                                        :debounceTime="2000"
                                        :clickFn="addEmployee"
                                        :canAdd="true"
                                        :addFn="() => manualEmployee = true"
                                      ></wg-search>
                                    </div>
                                </div>
                                <div v-else>
                                  <div class="wg-row">
                                    <div class="anm22-calendar-label-tiny-inline wg-col wg-md-8 wg-xs-8">
                                      <input
                                        class="anm22-calendar-input-text"
                                        type="email"
                                        v-model="emailExt"
                                        :placeholder="$anm22.strLang(lang, 'Add email...', 'Inserisci Email...')"
                                      >
                                    </div>
                                    <div class="wg-col wg-xs-4 wg-md-4">
                                      <input
                                          type="button"
                                          class="action-button anm22-calendar-input-submit"
                                          @click="inviteExt"
                                          :value="$anm22.strLang(lang, 'Invite', 'Invita')" 
                                        >
                                    </div>
                                  </div>
                                </div>
                              </template>
                              <template v-if="obj.user!=event.creator">
                                <template v-if="event.creator == idUsr">
                                  <img
                                    @click="delInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Rimuovi invitato"
                                    :src="$anm22.icons.getWorldIcon('deleteRed')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                  <template v-if="obj.permission==0">
                                    <img
                                      @click="adminInvite(obj.idWorldEventInvite)"
                                      style="cursor:pointer"
                                      title="Nomina Admin"
                                      :src="$anm22.icons.getWorldIcon('userAdminAdd')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                  </template>
                                  <template v-else>
                                    <img
                                      @click="delAdminInvite(obj.idWorldEventInvite)"
                                      style="cursor:pointer"
                                      title="Remove Admin"
                                      :src="$anm22.icons.getWorldIcon('userAdminRemove')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                  </template>
                                </template>
                                <template v-if="obj.status == 0 && utente.idWorldUser==idUsr">
                                  <br>
                                  <div style="display: block;">
                                    <br>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                                  </div>
                                </template>
                              </template>
                              <div class="anm22-calendar-icon-container"></div>
                              <div style="clear:both;"></div>
                            </div>
                          </span>
                        </span>
                      </span>
                      <hr>
                    </div>
                  </span>
                  <template v-if="event.creator == idUsr">
                  <div class="wg-row">
                    <div class="" @click="deleteEvent" style="cursor:pointer">
                      <img :src="$anm22.icons.getWorldIcon('deleteRed')" class="anm22-calendar-icon-inline">
                      <div class="anm22-calendar-field-inline anm22-calendar-field-inline-m">{{$anm22.strLang(lang, 'Delete Event', 'Elimina Evento')}}</div>
                    </div>
                  </div>
                  </template>
                </span>
              </form>
            </div>
          </div>

          <div v-else>
            <form @submit="checkForm">
              <div class="anm22-calendar-wrapper-calendar">
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Name Event', 'Nome Evento')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <input disabled
                      required
                      class="anm22-calendar-input-text"
                      id="name"
                      type="text"
                      v-model="event.name"
                      :placeholder="$anm22.strLang(lang, 'Insert name...', 'Inserisci nome evento...')"
                    >
                  </div>
                </div>
                <hr>
                <hr>
                <div class="wg-row">
                  <div
                      class="anm22-calendar-label-tiny wg-md-4 wg-xs-12"
                      >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <select disabled required class="com-anm22-app-select" v-model="event.work">
                      <option value="0"> Privato </option>   
                      <option v-for="(obj,index) in works"
                          :key="'work-'+index"
                          :value="obj.idWorldWork"
                        ><span v-if="currentWork!=obj.name"> {{ obj.name }}</span></option>
                    </select>
                  </div>
                </div>
                <hr>
                <hr>
                <div class="wg-row">
                  <div
                      class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                    >{{$anm22.strLang(lang, 'Start', 'Inizio')}}</div>
                  <div class="wg-col wg-xs-7 wg-md-5">
                    <input disabled type="date" v-model="startDate" required>
                  </div>
                  <div class="wg-col wg-xs-5 wg-md-3">
                    <input disabled type="time" v-model="startTime">
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'End', 'Fine')}}</div>
                  <div class="wg-col wg-xs-7 wg-md-5">
                    <input disabled id="end-date" type="date" v-model="endDate" required>
                  </div>
                  <div class="wg-col wg-xs-5 wg-md-3">
                    <input disabled type="time" v-model="endTime">
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">Timezone</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <select disabled class="input-elem com-anm22-app-select" v-model="event.timezone">
                      <option
                        :value="''"
                        selected
                        disabled
                      >{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                      <option
                          disabled
                          v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                          :key="'timezone-'+index"
                          :value="key"
                        >{{ obj[lang] }}</option>
                    </select>
                  </div>
                </div>
              </div>
              <div class="clear"></div>

              <hr>
              <div class="anm22-calendar-wrapper-calendar" style="padding-top:0;">
                <hr>
                <div class="anm22-calendar-label">
                  Luogo
                  <span class="labelFieldPlace"></span>
                </div>
                <hr>
                <template v-if="event.placeCity">
                  <iframe
                      width="100%"
                      height="450"
                      frameborder="0" style="border:0"
                      :src="'https://www.google.com/maps/embed/v1/place?key='+ mapsAPIKey +'&q=' + googleQuery" allowfullscreen>
                  </iframe>
                </template>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Name Location', 'Nome Luogo')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <input 
                      class="anm22-calendar-input-text"
                      type="text"
                      disabled
                      v-model="event.placeName"
                      :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                    >
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Address', 'Indirizzo')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-6">
                    <input disabled
                      class="anm22-calendar-input-text"
                      type="text"
                      v-model="event.placeStreet"
                      :placeholder="$anm22.strLang(lang, 'Street...', 'Via...')"
                    >
                  </div>
                  <div class="wg-col wg-xs-12 wg-md-2">
                    <input disabled
                      class="anm22-calendar-input-text"
                      type="text"
                      v-model="event.placeNumber"
                      :placeholder="$anm22.strLang(lang, 'N...', 'N.civico...')"
                    >
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'City', 'Città')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <input disabled
                      class="anm22-calendar-input-text"
                      type="text"
                      :placeholder="$anm22.strLang(lang, 'City...', 'Città...')"
                      v-model="event.placeCity"
                    >
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">C.A.P</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <input disabled
                      class="anm22-calendar-input-text"
                      type="text"
                      :placeholder="$anm22.strLang(lang, 'Postal Code...', 'CAP...')"
                      v-model="event.placeZip"
                    >
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Province', 'Provincia')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <input disabled
                      class="anm22-calendar-input-text"
                      type="text"
                      name="place_state"
                      value
                      :placeholder="$anm22.strLang(lang, 'Province...', 'Provincia...')"
                      v-model="event.placeState"
                    >
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Country', 'Paese')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <select  disabled class="input-elem com-anm22-app-select" v-model="event.placeCountry">
                      <option disabled
                        v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
                        :key="'country-'+index"
                        :value="key"
                      >{{ obj[lang] }}</option>
                    </select>
                  </div>
                </div>
                <hr>
                <div class="wg-row">
                  <div
                    class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                  >{{$anm22.strLang(lang, 'Notes', 'Note')}}</div>
                  <div class="wg-col wg-xs-12 wg-md-8">
                    <textarea disabled v-model="event.notes" rows="3" name="notes"></textarea>
                  </div>
                </div>
              </div>
              <span v-if="!event.idWorldEvent">
                <input
                  type="submit"
                  :value="$anm22.strLang(lang, 'Add event','Aggiungi evento')"
                  class="action-button anm22-calendar-input-submit"
                >
              </span>
              <span v-else>
                <!-- LINK AL PROGETTO TASKS SE PRESENTE -->
                <div v-if="event.projectRef" class="wg-row">
                  <div class="anm22-calendar-wrapper-calendar">
                    <div class="anm22-calendar-label">
                      {{ $anm22.strLang(lang, 'Project', 'Progetto') }}
                    </div>
                    <a 
                        :href="'https://tasks.anm22.it/project/' + event.projectRef"
                        class="wg-row project-link" 
                        :style="{borderLeft: '3px solid ' + projectBorderColor}"
                        >
                      <img :src="$anm22.icons.getWorldIcon('taskIcon')" class="com-anm22-app-img-fixed-height-m" style="margin-right:10px;" />
                      <div class="com-anm22-app-text-xl" >
                        {{ event.projectName }}
                      </div>
                    </a>
                  </div>
                </div>
                <!-- ---------------------------------------------- -->
                <hr style='color:#ccc;'>
                <span v-if="event.idWorldEvent">
                  <div class="anm22-calendar-wrapper-calendar">
                    <div class="anm22-calendar-label">{{$anm22.strLang(lang, 'Invited', 'Invitati')}}</div>
                    <p v-if="errors.length">
                      <b>{{$anm22.strLang(lang, 'Alert Messagge', 'Messaggio Informativo')}}</b>
                      <ul>
                        <li v-for="(error, index) in errors" :key="'error'+index">{{ error }}</li>
                      </ul>
                    </p>
                    <span v-for="(obj,index) in invites" :key="'invite-'+index">
                      <template v-if="!obj.user">
                        <div class="anm22-calendar-invite-container anm22-calendar-wrapper" style="box-shadow:none">
                          <img
                              class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                              :src="$anm22.getObjIcon(obj.user, 'userDefault')"
                            >
                            {{obj.email}}
                          <span
                              style="color: #aaa;"
                            >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                            -
                          <span
                              style="color: #bbb;"
                            >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                          <template v-if="event.creator == idUsr">
                            <img
                              @click="delInvite(obj.idWorldEventInvite)"
                              style="cursor:pointer"
                              title="Rimuovi invitato"
                              :src="$anm22.icons.getWorldIcon('deleteRed')"
                              class="anm22-calendar-icon-inline"
                            >   
                          </template>
                        </div>
                      </template>
                      <span v-for="(utente, index) in users" :key="'usr'+index">
                        <span v-if="utente.idWorldUser == obj.user">
                          <div class="anm22-calendar-invite-container">
                            <img
                              class="anm22-calendar-icon-inline-xl anm22-calendar-round anm22-calendar-invite-img"
                              :src="$anm22.getObjIcon(utente, 'userDefault')"
                            >
                            <div class="anm22-calendar-field-inline">
                              {{utente.name}} {{utente.surname}}
                              <span
                                style="color: #aaa;"
                              >{{$anm22.tableClasses.eventPermission().getById(obj.permission)[lang]}}</span>
                              -
                              <span
                                style="color: #aaa;"
                              >{{$anm22.tableClasses.inviteStatus().getById(obj.status)[lang]}}</span>
                              <div style="display: block;">
                            
                                <div v-if="obj.status == 1 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('deleteRed')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite,2)"
                                        >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                                  </small>
                                </div>
                                <div v-if="obj.status == 2 && idUsr == obj.user">
                                  <br>
                                  <small>
                                    <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('tick')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 1)"
                                        >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                      </div>
                                    </div>
                                    <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                      <img
                                        :src="$anm22.icons.getWorldIcon('maybe')"
                                        class="anm22-calendar-icon-inline"
                                      >
                                      <div class="anm22-calendar-field-inline">
                                        <small
                                          @click="eventStatus(obj.idWorldEventInvite, 3)"
                                        >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                      </div>
                                    </div>
                              
                                  </small>
                                </div>
                              </div>
                              <div v-if="obj.status == 3 && idUsr == obj.user">
                                <br>
                                <small>
                                  <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                    <img
                                      :src="$anm22.icons.getWorldIcon('tick')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                    <div class="anm22-calendar-field-inline">
                                      <small
                                        @click="eventStatus(obj.idWorldEventInvite, 1)"
                                      >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                    </div>
                                  </div>
                                  <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                    <img
                                      :src="$anm22.icons.getWorldIcon('deleteRed')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                    <div class="anm22-calendar-field-inline">
                                      <small
                                        @click="eventStatus(obj.idWorldEventInvite, 2)"
                                      >{{$anm22.strLang(lang, 'Not Participate', 'Non Parteciperò')}}</small>
                                    </div>
                                  </div>
                                </small>
                              </div>
                            </div>
                            <template v-if="obj.permission==1 && utente.idWorldUser==idUsr">
                              <br>
                              <br>
                              <div class="wg-row" v-if="!manualEmployee">
                                <div class="anm22-calendar-label-tiny-inline wg-col wg-md-1 wg-xs-1">
                                  <img class="marg" width="20px" :src="$anm22.icons.getWorldIcon('addGreen')">
                                </div>
                                  <div class="wg-col wg-xs-11 wg-md-11">
                                    <wg-search
                                      :placeholder="$anm22.strLang(lang, 'Add Invitated', 'Aggiungi Invitati')"
                                      :url="'events/getemployees'"
                                      :debounceTime="2000"
                                      :clickFn="addEmployee"
                                      :canAdd="true"
                                      :addFn="() => manualEmployee = true"
                                    ></wg-search>
                                  </div>
                              </div>
                              <div v-else>
                                <div class="wg-row">
                                      <div class="anm22-calendar-label-tiny-inline wg-col wg-md-8 wg-xs-8">
                                        <input
                                          class="anm22-calendar-input-text"
                                          type="email"
                                          v-model="emailExt"
                                          :placeholder="$anm22.strLang(lang, 'Add email...', 'Inserisci Email...')"
                                        >
                                      </div>
                                      <div class="wg-col wg-xs-4 wg-md-4">
                                        <input
                                            type="button"
                                            class="action-button anm22-calendar-input-submit"
                                            @click="inviteExt"
                                            :value="$anm22.strLang(lang, 'Invite', 'Invita')" 
                                          >
                                      </div>
                                    </div>
                              </div>
                            </template>
                            <template v-if="obj.user!=event.creator">
                              <template v-if="event.creator == idUsr">
                                <img
                                    @click="delInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Rimuovi invitato"
                                    :src="$anm22.icons.getWorldIcon('deleteRed')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                <template v-if="obj.permission==0">
                                  <img
                                    @click="adminInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Nomina Admin"
                                    :src="$anm22.icons.getWorldIcon('userAdminAdd')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                </template>
                                <template v-else>
                                  <img
                                    @click="delAdminInvite(obj.idWorldEventInvite)"
                                    style="cursor:pointer"
                                    title="Remove Admin"
                                    :src="$anm22.icons.getWorldIcon('userAdminRemove')"
                                    class="anm22-calendar-icon-inline"
                                  >
                                </template>
                              </template>
                              <template v-if="obj.status == 0 && utente.idWorldUser==idUsr">
                                <br>
                                <div style="display: block;">
                                  <br>
                                  <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                    <img
                                      :src="$anm22.icons.getWorldIcon('tick')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                    <div class="anm22-calendar-field-inline">
                                      <small
                                        @click="eventStatus(obj.idWorldEventInvite, 1)"
                                      >{{$anm22.strLang(lang, 'Participate', 'Parteciperò')}}</small>
                                    </div>
                                  </div>
                                  <div class="anm22-calendar-invite-state" style="cursor:pointer">
                                    <img
                                      :src="$anm22.icons.getWorldIcon('deleteRed')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                    <div class="anm22-calendar-field-inline">
                                      <small
                                        @click="eventStatus(obj.idWorldEventInvite, 2)"
                                      >{{$anm22.strLang(lang, 'Not attending', 'Non Parteciperò')}}</small>
                                    </div>
                                  </div>
                                  <div class="anm22-calendar-invite-state-last" style="cursor:pointer">
                                    <img
                                      :src="$anm22.icons.getWorldIcon('maybe')"
                                      class="anm22-calendar-icon-inline"
                                    >
                                    <div class="anm22-calendar-field-inline">
                                      <small
                                        @click="eventStatus(obj.idWorldEventInvite, 3)"
                                      >{{$anm22.strLang(lang, 'Maybe', 'Forse')}}</small>
                                    </div>
                                  </div>
                                </div>
                              </template>
                            </template>
                            <div class="anm22-calendar-icon-container"></div>
                            <div style="clear:both;"></div>
                          </div>
                        </span>
                      </span>
                    </span>
                    <hr>
                  </div>
                </span>
                <!-- Se sono il creatore posso eliminare l'evento -->
                <template v-if="event.creator == idUsr">
                  <div class="wg-row">
                    <div class="" @click="deleteEvent" style="cursor:pointer">
                      <img :src="$anm22.icons.getWorldIcon('deleteRed')" class="anm22-calendar-icon-inline">
                      <div class="anm22-calendar-field-inline anm22-calendar-field-inline-m">{{$anm22.strLang(lang, 'Delete Event', 'Elimina Evento')}}</div>
                    </div>
                  </div>
                </template>
              </span>
            </form>
          </div>
        </template>
      </template>
      <template v-else>
        <form  @submit="checkForm">
          <div class="anm22-calendar-wrapper-calendar">
         
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Name Event', 'Nome Evento')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <input 
                  required
                  class="anm22-calendar-input-text"
                  id="name"
                  type="text"
                  v-model="event.name"
                  :placeholder="$anm22.strLang(lang, 'Insert name...', 'Inserisci nome evento...')"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                  class="anm22-calendar-label-tiny wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Calendar', 'Calendario')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <template v-if="currentWork!='my'">
                  <select required class="com-anm22-app-select" v-model="event.work"> 
                    <option value="0">{{ $anm22.strLang(lang, 'Private', 'Privato') }}</option>   
                    <option v-for="(obj,index) in works"
                        :key="'work-'+index"
                        :value="obj.idWorldWork"
                      ><span v-if="currentWork!=obj.name"> {{ obj.name }}</span></option>
                  </select>
                </template>
                <template v-else>
                  <select required class="com-anm22-app-select" v-model="event.work">
                    <option value="0">{{ $anm22.strLang(lang, 'Private', 'Privato') }}</option>
                    <option v-for="(obj,index) in works"
                      :key="'work-'+index"
                      :value="obj.idWorldWork"
                    >{{ obj.name }}</option>
                  </select>
                </template>
              </div>
            </div>
            <div class="clear"></div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Start', 'Inizio')}}</div>
              <div class="wg-col wg-xs-7 wg-md-5">
                <input type="date" v-model="startDate" required>
              </div>
              <div class="wg-col wg-xs-5 wg-md-3">
                <input type="time" v-model="startTime" required>
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline labelDateTo wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'End', 'Fine')}}</div>
              <div class="wg-col wg-xs-7 wg-md-5">
                <input id="end-date" type="date" v-model="endDate" required>
              </div>
              <div class="wg-col wg-xs-5 wg-md-3">
                <input type="time" v-model="endTime" required>
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">Timezone</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                
                <select class="input-elem com-anm22-app-select" v-model="event.timezone">
                  <option :value="null" disabled hidden>{{ $anm22.strLang(lang, 'Select', 'Seleziona') }}</option>
                  <option
                    v-for="(obj,key,index) in $anm22.tableClasses.worldTimezone().getAll()"
                    :key="'timezone-'+index"
                    :value="key"
                  >{{ obj[lang] }}</option>
                </select>
              </div>
            </div>
          </div>
          <div class="clear"></div>

          <hr>
          <div class="anm22-calendar-wrapper-calendar" style="padding-top:0;">
            <hr>
            <div class="anm22-calendar-label">
              Luogo
              <span class="labelFieldPlace"></span>
            </div>
            <hr>
            <!-- <template v-if="event.placeCity">
            <iframe
                    width="100%"
                    height="450"
                    frameborder="0" style="border:0;display:none;"
                    :src="'https://www.google.com/maps/embed/v1/place?key='+ mapsAPIKey +'&q=' + googleQuery" allowfullscreen>
                  </iframe>
            </template> -->
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Name Location', 'Nome Luogo')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <wg-search
                  v-if="!event.placeName && manual == false"
                  :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                  :url="'events/getplaces'"
                  :debounceTime="2000"
                  :clickFn="addPlace"
                  :canAdd="true"
                  :addFn="() => manual = true"
                ></wg-search> 
                <input
                  v-else
                  class="anm22-calendar-input-text"
                  type="text"
                  v-model="event.placeName"
                  :placeholder="$anm22.strLang(lang, 'Place...', 'Luogo...')"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Address', 'Indirizzo')}}</div>
              <div class="wg-col wg-xs-12 wg-md-6">
                <input
                  class="anm22-calendar-input-text"
                  type="text"
                  v-model="event.placeStreet"
                  :placeholder="$anm22.strLang(lang, 'Street...', 'Via...')"
                >
              </div>
              <div class="wg-col wg-xs-12 wg-md-2">
                <input
                  class="anm22-calendar-input-text"
                  type="text"
                  v-model="event.placeNumber"
                  :placeholder="$anm22.strLang(lang, 'N...', 'N.civico...')"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'City', 'Città')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <input
                  class="anm22-calendar-input-text"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'City...', 'Città...')"
                  v-model="event.placeCity"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12">C.A.P</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <input
                  class="anm22-calendar-input-text"
                  type="text"
                  :placeholder="$anm22.strLang(lang, 'Postal Code...', 'CAP...')"
                  v-model="event.placeZip"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                  class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
                >{{$anm22.strLang(lang, 'Province', 'Provincia')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <input
                  class="anm22-calendar-input-text"
                  type="text"
                  name="place_state"
                  value
                  :placeholder="$anm22.strLang(lang, 'Province...', 'Provincia...')"
                  v-model="event.placeState"
                >
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Country', 'Paese')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <select class="input-elem com-anm22-app-select" v-model="event.placeCountry">
                  <option
                    v-for="(obj,key,index) in $anm22.tableClasses.worldCountry().getAll()"
                    :key="'country-'+index"
                    :value="key"
                  >{{ obj[lang] }}</option>
                </select>
              </div>
            </div>
            <hr>
            <div class="wg-row">
              <div
                class="anm22-calendar-label-tiny-inline wg-col wg-md-4 wg-xs-12"
              >{{$anm22.strLang(lang, 'Notes', 'Note')}}</div>
              <div class="wg-col wg-xs-12 wg-md-8">
                <textarea v-model="event.notes" rows="3" name="notes"></textarea>
              </div>
            </div>
          </div>
          <span v-if="!event.idWorldEvent">
            <input
              type="submit"
              :value="$anm22.strLang(lang, 'Add event','Aggiungi evento')"
              class="action-button anm22-calendar-input-submit"
            >
          </span>
        </form>
      </template>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  props: {
    eventRef: Object,
    currentWork: [Number,String]
  },
  data() {
    return {
      event: { ...this.eventRef },
      errors: [],
      manual: false,
      manualEmployee: false,
      // Select progetti
      editingProject: false,
      projectOptions: [],
      projectSelect: null
    };
  },
  computed: {
    ...mapState({
      user: state => state.auth.user,
      mapsAPIKey: state => state.config.mapsAPIKey,
      lang: state => state.lang
    }),
    works() {
      return this.$store.getters["works/getAll"];
    },
    googleQuery(){
      let query;
      if(this.event.placeName != undefined)
      {
        query=this.event.placeName + ',+'
      }
      else{
        query="";
      }
      if(this.event.placeStreet!=undefined ){
        query+=this.event.placeStreet + '+'
      }
      else{
        query+="";
      }
      if(this.event.placeNumber!=undefined){
        query+=this.event.placeNumber + ',+'
      }
      else{
        query+="";
      }
      if(this.event.placeCity!=undefined){
        query+=this.event.placeCity + ',+'
      }
      else{
        query+="";
      }
       if(this.event.placeZip!=undefined){
        query+=this.event.placeZip + ',+'
      }
      else{
        query+="";
      }
       if(this.event.placeState!=undefined){
        query+=this.event.placeState + ',+'
      }
      else{
        query+="";
      }
       if(this.event.placeCountry!=undefined){
        query+=this.event.placeCountry 
      }
      else{
        query+="";
      }
       return query;
    },
    workCurrent(){
      return this.$store.getters['works/get'](this.currentWork);
    },
    filterEvent(){
      return this.$store.getters['events/get'](this.event);
    },
    users() {
      return this.$store.getters["users/getAll"];
    },
    //recupera inviti dell 'evento selezionato
    invites() {
      return this.$store.getters["invites/getByEvent"](this.eventRef.idWorldEvent);
    },
    inviteWork(){
      return this.invites.find(invite => this.event.idWorldEvent === invite.event && invite.user !== this.user.idWorldUser);
      // let result = null;
      // this.invites.forEach(element => {
      //   if(this.event.idWorldEvent == element.event && element.user != this.idUsr){
      //     result=element;
      //   }
      // });
      // return result;
    },
    idUsr() {
      return this.user.idWorldUser;
    },
    invite(){
      return this.invites.find(invite => invite.user === this.user.idWorldUser);
      // let result = null;
      // this.invites.forEach(invite => {
      //   if(invite.user == this.idUsr) {
      //     result=invite;
      //   }
      // });     
      // return result;
    },
    startDate: {
      get() {       
         return this.$moment.unix(this.event.startTimestamp).format("YYYY-MM-DD");
      },
      set: _.debounce(function(newVal) {
        this.event.startTimestamp = Number(
          this.$moment(newVal + " " + this.startTime)
            .utc()
            .format("X")
        );
      },1000)
    },
    startTime: {
      get() {
        if(this.event.startTimestamp < this.event.endTimestamp)
        {
          return  this.$moment.unix(this.event.startTimestamp).format("HH:mm");
        }
        else
        {
          this.event.startTimestamp = this.event.endTimestamp;
          return  this.$moment.unix(this.event.startTimestamp).format("HH:mm");  
        }  
      },
       set: _.debounce(function(newTime) {
        this.event.startTimestamp = Number(
          this.$moment(this.startDate + " " + newTime)
            .utc()
            .format("X")
        );
      },1000)
    },
    endDate: {
      get() {
        return this.$moment.unix(this.event.endTimestamp).format("YYYY-MM-DD");
      },
        set: _.debounce(function(newValEnd) {
        this.event.endTimestamp = Number(
          this.$moment(newValEnd + " " + this.endTime)
            .utc()
            .format("X")
        );
      },1000)
    },
    endTime: {
      get() {
         return this.$moment.unix(this.event.endTimestamp).format("HH:mm");
      },
       set: _.debounce(function(newTime) {
        this.event.endTimestamp = Number(
          this.$moment(this.endDate + " " + newTime)
            .utc()
            .format("X")
        );
      },1000)
    },
    projectBorderColor() {
      switch (this.event.projectStatus) {
        case 1:
          return "#bdbdbd";
        case 2:
          return "#ffeb3b";
        case 3:
          return "#01d479";
        case 4:
          return "#00b0ff";
        case 5:
          return "#ff0000";
      }
    },
    // In futuro pensare ad una implementazione mediante libreria custom come permessi modifica Tasks
    canEditProjectLink() {
      return this.currentWork !== 474 && this.event.type !== 4 && this.event.type !== 8;
    },
  },
  created() {
    /* CODE REVIEW -- INSERIRE QUESTO CONTROLLO DIRETTAMENTE NEL TEMPLATE SENZA USARE UNA ULTERIORE VARIABILE */
    if(this.event.placeName) {
      this.manual = true;
    }
    if(!this.event.work && this.currentWork!='my'){
      this.event.work = this.currentWork;
    }
    else if(!this.event.work && this.currentWork ==='my'){
      this.event.work = 0;
    }
    if(!this.event.timezone){
      this.event.timezone = "Europe/Rome";
    }
    if(!this.event.placeCountry){
      this.event.placeCountry = "it";
    }
  },
  methods: {
    addPlace(idPlace) {
      this.$http
        .post("events/setlabelplace", {
          idPlace: idPlace
        }, {
          withCredentials: true
        })
        .then(response => {
          this.event.contactPlace = response.data.place.idContactsPlace;
          this.event.placeName = response.data.place.name;
          this.event.placeStreet = response.data.place.addressStreet;
          this.event.placeNumber = response.data.place.addressNumber;
          this.event.placeCity = response.data.place.addressCity;
          this.event.placeZip = response.data.place.addressZip;
          this.event.placeState = response.data.place.addressState;
          this.event.placeCountry = response.data.place.addressCountry;
          this.manual = true;
        })
        .catch(error => {});
    },
    addEmployee(idUser) {
      //alert(idUser);
      this.$http
        .post("events/setlabelinvited", {
          idUser: idUser,
          idWorldEvent: this.event.idWorldEvent
        }, {
          withCredentials: true
        })
        .then(response => {
          //console.log(response.data);
          if (response.data == 1) {
            this.errors.push("Utente già aggiunto alla lista degli invitati");
          } else {
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: [response.data.invites]
            });
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: [response.data.users]
            });
          }
        })
        .catch(error => {});
    },
    inviteExt(){
      this.$http
        .post("events/invite", {
          event: this.event,
          email: this.emailExt
        }, {
          withCredentials: true
        })
        .then(response => {
          //console.log(response.data);
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites]
          });
        })
        .catch(error => {});
        this.manualEmployee = false
    },
    checkForm: function(e) {
      if (this.name) {
        return true;
      }
      this.errors = [];
      if (!this.name) {
        this.errors.push("Titolo richiesto.");
      }
      e.preventDefault();
      //Salvo oggetto
      this.$http
        .post("events/new", {
          event: this.event
          //place: this.place
        }, {
          withCredentials: true
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [response.data.event]
            }),
            
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: [response.data.invites]
            }),
            this.$store.dispatch("users/update", {
              vlf: this.$vlf("users"),
              objs: [response.data.users]
            })
          ]).then(() => {
            this.$anm22.eventBus.$emit("wg-modal-close");
          });
        })
        .catch(error => console.log(error));
    },
    delInvite(idWorldEventInvite) {
      //alert(idWorldEventInvite);
      this.$http
        .post("events/delinvite", {
          idWorldEventInvite: idWorldEventInvite
        }, {
          withCredentials: true
        })
        .then(response => {
          
          this.$store.dispatch("invites/delete", {
            vlf: this.$vlf("invites"),
            obj: response.data.invites
          });
        })
        .catch(error => {});
    },
    adminInvite(idWorldEventInvite) {
      this.$http
        .post("events/admininvite", {
          idWorldEventInvite: idWorldEventInvite
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites]
          });
          
        })
        .catch(error => {});
    },
    eventStatus(idWorldEventInvite, status) {
      this.$http
        .post("events/statusinvite", {
          idWorldEventInvite: idWorldEventInvite,
          status: status
        }, {
          withCredentials: true
        })
        .then(response => {
          //console.log(response.data);
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites]
          });
        })
        .catch(error => {});
    },
    delAdminInvite(idWorldEventInvite) {
      this.$http
        .post("events/removeadmininvite", {
          idWorldEventInvite: idWorldEventInvite
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("invites/update", {
            vlf: this.$vlf("invites"),
            objs: [response.data.invites]
          });
        })
        .catch(error => {});
    },
    update() {
      this.$http
        .post("events/update", {
          event: this.event
           //place: this.place
        }, {
          withCredentials: true
        })
        .then(response => {
          return Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: [response.data.event]
            }),
            this.$store.dispatch("places/update", {
               vlf: this.$vlf("places"),
               objs: [response.data.place]
             }),
            this.$store.dispatch("invites/update", {
              vlf: this.$vlf("invites"),
              objs: [response.data.invites]
            })
          ]).then(() => {
            this.$anm22.eventBus.$emit("wg-modal-close");
          });
        })
        .catch(error => console.log(error));
    },
    deleteEvent() {
      this.$http
        .post("events/del", {
          event: this.event
        }, {
          withCredentials: true
        })
        .then(response => {
          this.$store.dispatch("events/delete", {
            vlf: this.$vlf("events"),
            obj: this.event
          });
          this.$anm22.eventBus.$emit("wg-modal-close");
        })
        .catch(error => console.log(error));
    },
    setProjectLink(projectId) {
      this.$http
        .post('events/setprojectlink', {
          eventId: this.event.idWorldEvent,
          projectId: this.projectSelect
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events
            })
            .then(() => {
              const newEvent = response.data.events[0];
              this.editingProject = false;
              this.projectOptions = [];
              this.projectSelect = null;
              // Aggiorno evento
              this.event.projectRef = newEvent.projectRef;
              this.event.projectStatus = newEvent.projectStatus;
              this.event.projectName = newEvent.projectName;
            })
          ])
        })
        .catch(e => console.log(e));
    },
    editProjectRef() {
      this.$http
        .post('events/getprojects', {
          workId: this.currentWork
        }, {
          withCredentials: true
        })
        .then(response => {
          this.projectOptions = response.data.options;
          this.projectSelect = this.event.projectRef || '';
          this.editingProject = true;
        })
        .catch(e => console.log(e));
    },
    stopEditProjectRef() {
      this.editingProject = false;
      this.projectOptions = [];
      this.projectSelect = null;
    },
    deleteProjectRef() {
      this.$http
        .post('events/deleteprojectlink', {
          eventId: this.event.idWorldEvent
        }, {
          withCredentials: true
        })
        .then(response => {
          Promise.all([
            this.$store.dispatch("events/update", {
              vlf: this.$vlf("events"),
              objs: response.data.events
            })
            .then(() => {
              this.editingProject = false;
              this.projectOptions = [];
              this.projectSelect = null;
              // Aggiorno evento
              delete this.event.projectRef;
            })
          ])
        })
        .catch(e => console.log(e));
    }
  },
};
</script>

<style lang="scss" scoped>

/*form styles*/
#msform {
  width: 100%;
  margin: 50px auto;
  text-align: center;
  position: relative;
}
#msform fieldset {
  background: white;
  border: 0 none;
  border-radius: 1px;
  padding: 10px 10px;
  box-sizing: border-box;
  width: 100%;
  margin: 0 2%;
  /*stacking fieldsets above each other*/
  position: relative;
}
hr {
  border: 1px solid #fff;
  color: #ddd;
}
/*Hide all except first fieldset*/
//#msform fieldset:not(:first-of-type) {
  //display: none;
//}
/*inputs*/
#msform input,
#msform textarea {
  padding: 15px;
  border: 1px solid #ccc;
  border-radius: 3px;
  margin-bottom: 10px;
  width: 100%;
  box-sizing: border-box;
  font-family: montserrat;
  color: #2c3e50;
  font-size: 13px;
}
.anm22-calendar-wrapper-calendar {
    width: 100%;
    box-sizing: border-box;
    padding: 20px 0;
    margin-bottom: 20px;
    background-color: #fff;
    border-bottom: none;
}
@media (max-width: 500px) {
  .marg {
    margin-left:-9px;
  }
}
/*buttons*/
#msform .action-button {
  width: 100px;
  background: #27ae60;
  font-weight: bold;
  color: white;
  border: 0 none;
  border-radius: 1px;
  cursor: pointer;
  padding: 10px 5px;
  margin: 10px 5px;
}
#msform .action-button:hover,
#msform .action-button:focus {
  box-shadow: 0 0 0 2px white, 0 0 0 3px #27ae60;
}
/*headings*/
.fs-title {
  font-size: 15px;
  text-transform: uppercase;
  color: #2c3e50;
  margin-bottom: 10px;
}
.fs-subtitle {
  font-weight: normal;
  font-size: 13px;
  color: #666;
  margin-bottom: 20px;
}
/*progressbar*/
#progressbar {
  margin-bottom: 30px;
  overflow: hidden;
  /*CSS counters to number the steps*/
  counter-reset: step;
}
#progressbar li {
  list-style-type: none;
  color: white;
  text-transform: uppercase;
  font-size: 9px;
  width: 33.33%;
  float: left;
  position: relative;
}
#progressbar li:before {
  content: counter(step);
  counter-increment: step;
  width: 20px;
  line-height: 20px;
  display: block;
  font-size: 10px;
  color: #333;
  background: white;
  border-radius: 3px;
  margin: 0 auto 5px auto;
}
/*progressbar connectors*/
#progressbar li:after {
  content: "";
  width: 100%;
  height: 2px;
  background: white;
  position: absolute;
  left: -50%;
  top: 9px;
  z-index: -1; /*put it behind the numbers*/
}
#progressbar li:last-child {
  /*connector not needed before the first step*/
  content: none;
}
/*marking active/completed steps green*/
/*The number of the step and the connector before it = green*/
#progressbar li.active:before,
#progressbar li.active:after {
  background: #27ae60;
  color: white;
}

#com-anm22-headBar-searchBar-hint {
  display: block;
}
#com-anm22-headBar-searchBar-msg-box {
  display: block;
}
#com-anm22-headBar-searchBar-msg {
  display: flex;
  align-items: center;
  flex-wrap: nowrap;
  -webkit-flex-wrap: nowrap;
  padding: 10px;
}

#com-anm22-headBar-searchBar-msg .close {
  position: static;
  margin-left: auto;
}

#anm22-headbar-notifications-num {
  position: absolute;
  font-size: 13px;
  font-weight: bold;
  color: #fff;
  background: #f00;
  width: 16px;
  height: 16px;
  border-radius: 10px;
  text-align: center;
  line-height: 1;
  box-sizing: border-box;
  padding-top: 2px;
  bottom: 8px;
  right: 8px;
}

#anm22-world-menu-userMenu {
  border-left: 1px #ccc solid;
  border-top: 1px #ccc solid;
  width: 59px;
  position: absolute;
  top: 59px;
  right: 0px;
  background: #fff;
}

#anm22-world-menu-userMenu-sub {
  position: absolute;
  width: 75%;
  width: calc(100% - 57px);
  width: calc(100vw - 57px);
  max-width: 432px;
  min-width: 200px;
  height: 200px;
  background-color: #fff;
  right: 58px;
  top: -1px;
  border: 1px solid #ccc;

  .notification-div {
    margin: 3px;
    background-color: #eee;
    font-size: 14px;
    padding: 5px;
  }

  .notification-img {
    width: 30px;
    display: inline-block;
  }
}

.project-link {
  flex-wrap: nowrap;
  align-items: center;
  padding: 5px 5px 5px 10px;
  border-radius: 2px;
  &:hover {
    background-color: #fff;
  }
}
.icon-button {
  margin-left:auto;
  margin-right:10px;
  align-items: center;
  padding: 5px;
  border-radius: 4px;
  flex-wrap: nowrap;
  cursor: pointer;
  &:hover {
    background-color: #ddd;
  }
}
</style>